module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("45dma"))).then(() => parcelRequire('9Lwss'));